var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExam({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4695 12.7826L14.7865 13.2526V2.61257C14.7862 2.23697 14.6631 1.87177 14.436 1.57261C14.2089 1.27346 13.8902 1.05677 13.5285 0.955566C13.9654 0.989168 14.3812 1.157 14.719 1.43609C15.0568 1.71518 15.3001 2.09186 15.4155 2.51457L17.6655 10.6746C17.7262 10.8915 17.7433 11.1183 17.716 11.3419C17.6886 11.5655 17.6173 11.7815 17.5062 11.9775C17.395 12.1734 17.2462 12.3454 17.0683 12.4836C16.8903 12.6217 16.6869 12.7234 16.4695 12.7826V12.7826Z",
    fill: "url(#paint0_linear_101_109)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.2695 0.893555H12.8435C13.2413 0.893555 13.6229 1.05159 13.9042 1.33289C14.1855 1.6142 14.3435 1.99573 14.3435 2.39355V16.1066C14.3435 16.2379 14.3176 16.3679 14.2674 16.4892C14.2171 16.6106 14.1435 16.7208 14.0506 16.8137C13.9577 16.9065 13.8475 16.9802 13.7262 17.0304C13.6049 17.0807 13.4748 17.1066 13.3435 17.1066H1.2695C1.00428 17.1066 0.74993 17.0012 0.562394 16.8137C0.374858 16.6261 0.269501 16.3718 0.269501 16.1066V1.89355C0.269501 1.62834 0.374858 1.37398 0.562394 1.18645C0.74993 0.998912 1.00428 0.893555 1.2695 0.893555V0.893555Z",
    fill: "url(#paint1_linear_101_109)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46551 3.50854H3.93951V4.57154H8.46551V3.50854Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71049 13.3285H10.3745V14.4985H3.9805V7.05554H10.2985V8.22554H5.71049V10.1605H9.9235V11.3195H5.71049V13.3285Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_101_109",
    x1: 15.6286,
    y1: 0.955566,
    x2: 15.6286,
    y2: 13.2526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8269EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8269EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_101_109",
    x1: 7.3065,
    y1: 0.893555,
    x2: 7.3065,
    y2: 17.1066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8269EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8269EC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExam);
export default __webpack_public_path__ + "static/media/exam.5ca5c724916029cc90f9b5ca8aa4d9e0.svg";
export { ForwardRef as ReactComponent };